import { type SVGProps } from 'react';

import { withDynamicStroke } from '../../withDynamicStroke';
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m.75-14a.75.75 0 0 0-1.5 0v1a.75.75 0 0 0 1.5 0zm0 3.5a.75.75 0 0 0-1.5 0V16a.75.75 0 0 0 1.5 0z"
      clipRule="evenodd"
    />
  </svg>
);
export const IconInformationCircleSolid = withDynamicStroke(Icon);
